import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ContactList from './ContactList';

const Contact = () => {
	return (
		<Routes>
			<Route path="/" element={<ContactList />} />
			<Route path="*" element={<span>no match</span>} />
		</Routes>
	);
};

export default Contact;
